export default __webpack_public_path__ + "static/media/sidebar-icon-marketplace.c529a248.svg";